/*
Sohel      09/21/2022 698592321 Fixed Client Maintainance Bugs
Saikrishna 10/07/2022 698592321 Client maintenance bugs jira
Suresh Peddavoora 10/30/2022 698592321  Added Class Name for Button Enhancements
Suresh Peddavoora 10/31/2022 698592321  Changed Header Position
Dilip  11/02/2022 698592321  special character validation removed
Raghu  11/14/2022 698592321  Responsive Alignment Fixes
Lalitha 11/16/2022 698592321 Renamed in Zip Validation
*/
import React, {useState, useEffect, useContext} from 'react';
import {useForm} from 'react-hook-form';
import {
  TextField,
  FormControl,
  Button,
  FormHelperText,
  MenuItem,
  Typography,
} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory, useLocation} from 'react-router';
import LandingPage from '../../LandingPage';
import {ArrowBack} from '@material-ui/icons';
import {STATE} from '../../../constants/Lookup';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {getOptions} from '../../../util/GetDropDownOptions';
import ClientContactInfoTable from './ClientContactInfoTable';
import {getObject} from '../../../util/GetDropdownObject';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  postParentContact,
  resetMessage,
  resetduplicateParentMessage,
  fetchDropDowns,
} from '../../../redux/reducers/client-maintainance/ClientContact';
// import { fetchDropDowns } from "../../../redux/reducers/client-maintainance/ClientGeneral";
import {
  postParentClientName,
  resetParentClient,
} from '../../../redux/reducers/client-maintainance/ParentClient/ParentClientName';
import {ThemeContext} from '../../../themes/ThemeProvider';
import AppContext from '../../../components/contextProvider/AppContextProvider/AppContext';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';

const ParentForm = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const parentTableData = location?.state?.parentData && location.state.parentData;
  const {dropDownData} = useSelector(({clientContact}) => clientContact);
  const [openMenuItem, setOpenMenuItem] = useState(false);
  const [duplicateErr, setDuplicateErr] = useState(false);
  const [parentDataVal, setParentDataVal] = useState([]);
  const {roleData} = useSelector(({role}) => role);
  const disabledByRole = roleData?.window?.['Client Maintenance']?.PC;
  const {parentClientNameData} = useSelector(({parentClientName}) => parentClientName);
  const {
    duplicateParentMsg,
    parentPostAddStatus,
    clientContactStatus,
    parentClientID,
    isLoading,
    successMsg,
  } = useSelector(({clientContact}) => clientContact);
  useEffect(() => {
    if (duplicateParentMsg === 'Parent name already exist') {
      setDuplicateErr(true);
    }
  }, [duplicateParentMsg]);
  useEffect(() => {
    if (parentClientNameData?.length > 0) {
      setParentDataVal(parentClientNameData);
    }
  }, [parentClientNameData]);
  const getParentVal = (data, val) => {
    const parentData = data?.filter((item) => {
      return (
        item.parentClientName.toLowerCase().replaceAll(' ', '') ===
        val.toLowerCase().replaceAll(' ', '')
      );
    });
    let res = false;
    if (
      parentData?.length > 0 &&
      parentData[0].parentClientName.toLowerCase().replaceAll(' ', '') ===
        val.toLowerCase().replaceAll(' ', '')
    ) {
      res = true;
    } else {
      res = false;
    }
    return res;
  };
  const initialValues = {
    parentName: parentTableData?.parentClientName ? parentTableData.parentClientName : '',
    addressLine1: parentTableData?.addressLine1 ? parentTableData.addressLine1 : '',
    addressLine2: parentTableData?.addressLine2 ? parentTableData.addressLine2 : '',
    city: parentTableData?.city ? parentTableData.city : '',
    state: parentTableData?.state ? getObject(parentTableData.state, 'STATE', dropDownData) : '',
    zip: parentTableData?.zip ? parentTableData.zip : '',
  };

  const validationSchema = Yup.object().shape({
    state: Yup.object()
      .test('state', 'State is required', (val) => {
        return val?.value;
      })
      .typeError('State is required'),
    parentName: Yup.string().required('Parent client name is required')
      .test('parentName', 'Parent client name already exists', function(val) {
        if (getParentVal(parentDataVal, val?.trim())) {
          return false;
        } else {
          return true;
        }
      })
      .max(50, 'Parent client name cannot exceed 50 characters'),
    addressLine1: Yup.string()
      .required('Address line 1 is required')
      .max(50, 'Address line 1 cannot exceed 50 characters'),
    addressLine2: Yup.string().max(50, 'Address line 2 cannot exceed 50 characters'),
    city: Yup.string().required('City is required').matches(/^[\w\-\s]+$/, 'Special characters are not allowed').max(20, 'City cannot exceed 20 characters'),
    zip: Yup.string()
      .required('Zip code is required')
      .max(9, 'Zip cannot exceed 9 digits')
      .min(5, 'Minimum 5 Digits are required')
      .matches(/^\d+$/, 'Only digits are allowed for this field '),
  });
  const classes = reusableInputStyles();
  const {register, handleSubmit, errors, control, reset, setValue} = useForm({
    mode: 'onChange',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    dispatch(fetchDropDowns());
  }, []);
  const [parentClient, setParentClient] = useState(null);
  useEffect(() => {
    if (clientContactStatus === 200) {
      setParentClient(parentClientID);
    }
  });
  useEffect(() => {
    if (parentPostAddStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [parentPostAddStatus, dispatch]);
  useEffect(() => {
    if (duplicateErr) {
      setTimeout(() => {
        dispatch(resetduplicateParentMessage());
        setDuplicateErr(false);
      }, 3000);
    }
  }, [duplicateErr, dispatch]);
  const onSubmit = (data) => {
    if (data) {
      dispatch(
        postParentContact({
          addressLine1: (data && data.addressLine1) || '',
          addressLine2: (data && data.addressLine2) || '',
          city: (data && data.city) || '',
          parentClientId: 0,
          parentClientName: (data && data.parentName) || '',
          state: data?.state?.valueCode ? data.state.valueCode : '',
          zip: data?.zip ? data.zip : '',
        }),
      );
    }
  };

  const debounceClientCode = (value) => {
    const data = {
      parentClientName: value,
      searchTerm: value,
    };
    dispatch(postParentClientName(data));
  };
  useEffect(() => {
    if (parentClientNameData?.length > 0) {
      setOpenMenuItem(true);
    } else {
      setOpenMenuItem(false);
      dispatch(resetParentClient());
    }
  }, [parentClientNameData]);

  window.onclick = function() {
    setOpenMenuItem(false);
  };
  const {sideBarStatus} = useContext(AppContext);

  useEffect(() => {
    if (sideBarStatus) {
      setOpenMenuItem(false);
    }
  }, [sideBarStatus]);

  return (
    <>
      <LandingPage showTabs={true}>
        <div className="global-field-dash-board">

          <div className={`${classes.cardBordernoneStyles} rounded`}>
            <div className="d-flex align-items-center mb-3">
              <Button
                className={`search-btn`}
                variant="outlined"
                type="button"
                onClick={() => {
                  history.push('/parent-client');
                }}
              >
                <ArrowBack className="mr-2" />
            BACK TO DASHBOARD
              </Button>
              <div>
                <Typography className="ml-4" variant="h4">
                        Add Parent Client
                </Typography>
              </div>
            </div>
            <div className={`mb-0`}>
              <>
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                  <div>

                    <div className="form-row global-field-textfields align-items-center">
                      <div className="col-md-4  col-sm-4 form-group">
                        <Controller
                          render={({value, onChange, ref}) => (
                            <TextField
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Parent Client Name"
                              margin="dense"
                              name="parentName"
                              variant="outlined"
                              value={value}
                              label="Parent Client Name"
                              error={errors && errors.parentName}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              autoComplete="off"
                              disabled={parentTableData?.parentClientId || parentClient}
                              inputRef={ref}
                              fullWidth
                              onChange={(e) => {
                                onChange(
                                  e.target.value.trim() === '' ?
                                    e.target.value.trim() :
                                    e.target.value,
                                );
                                setValue(
                                  'parentName',
                                  e.target.value.trim() === '' ?
                                    e.target.value.trim() :
                                    e.target.value,
                                );
                                if (e.target.value) {
                                  debounceClientCode(e.target.value?.trim());
                                } else if (e.target.value === '') {
                                  dispatch(resetParentClient());
                                  setOpenMenuItem(false);
                                }
                              }}
                              required
                            />
                          )}
                          control={control}
                          name="parentName"
                        />
                        <FormHelperText variant="outlined">
                          {errors.parentName?.message ? errors.parentName.message : ''}
                        </FormHelperText>
                        <div className="parentclient-popover">
                          {openMenuItem &&
                            parentClientNameData?.map((data, i) => (
                              <MenuItem key={i}>{data.parentClientName}</MenuItem>
                            ))}
                        </div>
                      </div>
                      <div className="col-md-4  col-sm-4 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Address Line 1"
                          margin="dense"
                          name="addressLine1"
                          variant="outlined"
                          label="Address Line 1"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={errors && errors.addressLine1}
                          inputRef={register}
                          onChange={(e) => {
                            setValue(
                              'addressLine1',
                              e.target.value.trim() === '' ? e.target.value.trim() : e.target.value,
                            );
                          }}
                          fullWidth
                          required
                          disabled={parentTableData?.parentClientId || parentClient}
                        />
                        <FormHelperText variant="outlined">
                          {errors.addressLine1?.message ? errors.addressLine1.message : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-4  col-sm-4 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Address Line 2"
                          margin="dense"
                          name="addressLine2"
                          variant="outlined"
                          label="Address Line 2"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={errors && errors.addressLine2}
                          inputRef={register}
                          fullWidth
                          disabled={parentTableData?.parentClientId || parentClient}
                        />
                        <FormHelperText variant="outlined">
                          {errors.addressLine2?.message ? errors.addressLine2.message : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-4 col-sm-4 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter City"
                          margin="dense"
                          name="city"
                          variant="outlined"
                          label="City"
                          error={errors && errors.city}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputRef={register}
                          fullWidth
                          required
                          onChange={(e) => {
                            setValue(
                              'city',
                              e.target.value.trim() === '' ? e.target.value.trim() : e.target.value,
                            );
                          }}
                          disabled={parentTableData?.parentClientId || parentClient}
                        />
                        <FormHelperText variant="outlined">
                          {errors.city?.message ? errors.city.message : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-4 col-sm-4 form-group">
                        <FormControl margin="dense" variant="outlined" fullWidth>
                          <Controller
                            render={(props) => (
                              <GuiAutoComplete
                                {...props}
                                classes={{
                                  option: classes.option,
                                }}
                                id="state"
                                options={getOptions(STATE, dropDownData)}
                                disabled={parentTableData?.parentClientId || parentClient}
                                size="small"
                                autoHighlight
                                getOptionLabel={(option) => {
                                  return option && option.valueCode && option.value ?
                                    option.valueCode + ' - ' + option.value :
                                    option.value === null ?
                                      option.valueCode :
                                      '';
                                }}
                                renderInput={(params) => (
                                  <GuiTextField
                                    className={`${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    fullWidth
                                    label="State"
                                    name="state"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    error={errors && errors.state}
                                    placeholder="Select State"
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off', // disable autocomplete and autofill
                                    }}
                                    required
                                  />
                                )}
                                onChange={(_, data) => {
                                  props.onChange(data);
                                }}
                              />
                            )}
                            name="state"
                            control={control}
                          />
                        </FormControl>
                        <FormHelperText variant="outlined">
                          {errors.state?.message ? errors.state.message : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-4 col-lg-2 col-sm-4 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Zip"
                          margin="dense"
                          name="zip"
                          variant="outlined"
                          label="Zip"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          required
                          error={errors && errors.zip}
                          inputRef={register}
                          onChange={(e) => {
                            setValue(
                              'zip',
                              e.target.value.trim() === '' ? e.target.value.trim() : e.target.value,
                            );
                          }}
                          fullWidth
                          disabled={parentTableData?.parentClientId || parentClient}
                        />
                        <FormHelperText variant="outlined">
                          {errors.zip?.message ? errors.zip.message : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-12 col-lg-2 col-sm-12 form-group">
                        <div className="d-flex global-buttons">
                          <Button
                            type="button"
                            onClick={() => reset(initialValues)}
                            variant="outlined"
                            className={`mx-1 reset-btn  ${classes.buttonRoot}`}
                            disabled={parentTableData?.parentClientId || parentClient}
                          >
                      Cancel
                          </Button>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`mx-1 search-btn ${classes.buttonRoot}`}
                            disabled={
                              parentTableData?.parentClientId || parentClient || !disabledByRole?.add
                            }
                          >
                      Save
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>


                  {isLoading && <PageLoader />}
                </form>
                {parentTableData?.parentClientId || parentClient ? (
                  <div className="mt-4">
                    <ClientContactInfoTable
                      parentClientID={parentClientID}
                    />
                  </div>
                ) : null}
                {duplicateErr && <ErrorSnackbar errorMsg={duplicateParentMsg} />}
                {successMsg && <SuccessSnackbar successMsg={successMsg} />}
              </>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};

export default ParentForm;
